// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SLi1a","toolsContainer":"styles_toolsContainer__89TI5","tool":"styles_tool__Kj25s"};